@if (visible) {
	<div class="copy-button-wrapper">
		<button [attr.data-test-id]="'copy-button-'+ standard.name" nbButton class="copy-button" status="warning" (click)="onCopyButtonClicked()" [disabled]="copyActionDisabled">
			<nb-icon icon="copy"></nb-icon>
			<span>{{ text }}</span>
		</button>
		<div class="notification" [ngClass]="{'visible': showCopiedNotification}">{{ 'copy-button.text' | translate }}</div>
	</div>
}
